import { VehicleController } from 'core/repositories/VehicleController';
import { Vehicle } from 'core/models/vehicle';
import { useVehicleRepository } from './useVehicleRepository';
import { DriveCommand, EmergencyMode, ControlMode } from 'core/models/drive';
import { useEffect } from 'react';
import { Project } from 'core/models/project';
import { Environment } from 'core/models/environment';

function convertToCommand(event: VehicleController.Event): Partial<DriveCommand> {
    switch (event.eventType) {
        case 'accel':
            return { accel: event.accel };
        case 'brake':
            return { brake: event.brake };
        case 'steering':
            return { steering: -event.steering };
        case 'blinker':
            return { blinker: event.blinker };
        case 'emergency':
            return { emergency: event.emergency ? EmergencyMode.Emergency : EmergencyMode.Normal };
        case 'controlMode':
            return { controlMode: event.controlMode ? ControlMode.Remote : ControlMode.Auto };
        case 'gear':
            return { gear: event.gear };
    }
}

export function useVehicleControllerBind(vehicleId: Vehicle.Id, projectId: Project.Id, environmentId: Environment.Id, controller: VehicleController) {
    const repository = useVehicleRepository();

    useEffect(() => {
        let hasUserInteract = false;
        const listener = (event: VehicleController.Event) => {
            const updatedStatus = convertToCommand(event);
            if (updatedStatus.emergency !== undefined || updatedStatus.controlMode !== undefined) {
                hasUserInteract = true;
            }
            if (!hasUserInteract) return;
            try {
                repository.postDriveCommand(vehicleId, projectId, environmentId, updatedStatus);
            } catch (e) {
                console.error(`cannot post vehicle status delta due to: ${JSON.stringify(e)}`);
            }
        };

        controller.addEventListener(listener);

        return () => {
            controller.removeEventListener(listener);
            repository.cancelPostDriveCommand(vehicleId);
        };
    }, [vehicleId, projectId, controller, repository, environmentId]);
}
